import styled from 'styled-components';
import { Tag } from 'antd';

const AntTag = styled(Tag)`
`;

export {
  AntTag
};
